import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
const EMPTY_SUMMARIES = [];
export const useClientAgreementSummaries = (customerId)=>{
    const { api } = useStoreActions();
    const businessId = useStore(selectors.user.businessId);
    const isVendor = useStore(selectors.user.isVendor);
    const enabled = !!customerId && !!businessId;
    const { data, isLoading, error } = useQueryState({
        queryKey: [
            QueryKeys.RelationshipSummaries,
            businessId,
            isVendor,
            customerId
        ],
        queryFn: ()=>api.relationship.getSummaries({
                businessId: businessId,
                customerId,
                type: 'agreementAndAdHoc',
                isVendor
            }),
        enabled,
        refreshOnHookMount: true
    });
    return {
        summaries: data !== null && data !== void 0 ? data : EMPTY_SUMMARIES,
        isLoading: enabled && isLoading,
        error
    };
};
